import { isEmpty, isObject } from './util';

const notInclude = {
    'im-if': true,
    'im-show': true,
    'im-html': true,
    'im-src': true,
    'im-key': true,
    'im-item': true,
    'im-error': true
}

function setAttributes(dom, attribs) {
    let attrs = attribs || {};
    for(let key in attrs) {
        if (!notInclude[key]) {
            dom.setAttribute(key, attrs[key])
        }
    }
}

function setIdClassName(dom, node) {
    if (node.id) {
        dom.setAttribute('id', node.id)
    }
    if (node.className) {
        dom.setAttribute('class', node.className)
    }
    if (node.is_show === false && dom.style) {
        dom.style.display = 'none';
    }
    if (node.inner_html && typeof node.inner_html === 'string') {
        dom.innerHTML = node.inner_html;
    }
}

export default function createElement(vnode, components) {
    let _components = components || this.components || {};
    switch(vnode.tagName) {
        case 'text':
            vnode.el = document.createTextNode(vnode.text || '');
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'div':
            vnode.el = document.createElement("div");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'span':
            vnode.el = document.createElement("span");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'li':
            vnode.el = document.createElement("li");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'ul':
            vnode.el = document.createElement("ul");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'p':
            vnode.el = document.createElement("p");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'a':
            vnode.el = document.createElement("a");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            break;
        case 'img':
            vnode.el = document.createElement("img");
            setAttributes(vnode.el, vnode.attribs);
            setIdClassName(vnode.el, vnode);
            if (vnode.src) {
                vnode.el.setAttribute('src', vnode.src);
            }
            if (vnode.error && typeof vnode.error == 'function') {
                vnode.el.onerror = vnode.error;
            }
            break;
        default:
            if (_components && _components[vnode.tagName]) {
                vnode.component = new _components[vnode.tagName]({
                    is_vm: true
                });
                let original_vnode_data;
                if (this._children && !isEmpty(vnode.key)) {
                    if (this._children[vnode.key] && this._children[vnode.key]._vm_data) {
                        original_vnode_data = this._children[vnode.key]._vm_data
                    }
                    this._children[vnode.key] = vnode.component;
                }
                if (isObject(vnode.v_item)) {
                    if (original_vnode_data) {
                        vnode.component.setData({ ...vnode.v_item, ...original_vnode_data });
                    } else {
                        vnode.component.setData(vnode.v_item);
                    }
                }
                vnode.el = vnode.component.vm_get_element();
            }
            break;
    }
}